import React from 'react';
import { Package, ArrowRight, Phone, MessageSquare } from 'lucide-react';
import { INVENTORY, CONTACT } from '../mock';

const Inventory = () => {
  const smsHref = `sms:+1${CONTACT.phone}?&body=${CONTACT.smsBody}`;
  return (
    <section id="for-sale" className="bg-app py-24 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <span className="text-xs tracking-[0.3em] text-sky-400 uppercase font-semibold">Inventory</span>
        <h2 className="mt-3 font-cond font-700 text-4xl md:text-5xl text-white">Items for Sale</h2>
        <p className="mt-4 text-gray-400 max-w-2xl">
          Quality devices, accessories, and tech gear. Check back soon — new inventory arriving regularly!
        </p>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {INVENTORY.map((item) => (
            <div key={item.id} className={`card-dark rounded-xl p-6 flex flex-col ${item.soldOut ? 'items-center text-center justify-center min-h-[240px]' : ''}`}>
              {item.soldOut ? (
                <>
                  <span className="w-12 h-12 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center">
                    <Package className="w-6 h-6 text-sky-400" />
                  </span>
                  <h3 className="mt-4 font-cond font-600 text-xl text-white">{item.name}</h3>
                  <p className="mt-2 text-sm text-gray-400">{item.desc}</p>
                </>
              ) : (
                <>
                  <div className="flex items-start justify-between">
                    <h3 className="font-cond font-600 text-xl text-white pr-3">{item.name}</h3>
                    <span className="font-cond font-700 text-lg text-sky-400 shrink-0">{item.price}</span>
                  </div>
                  <p className="mt-3 text-sm text-gray-400 flex-1 leading-relaxed">{item.desc}</p>
                  <a href={smsHref} className="mt-5 pt-4 border-t border-white/10 text-sm text-gray-300 hover:text-sky-400 transition-colors flex items-center gap-1">
                    Ask about this <ArrowRight className="w-4 h-4" />
                  </a>
                </>
              )}
            </div>
          ))}
        </div>

        <div className="mt-20 relative overflow-hidden rounded-2xl border border-white/10 p-10 md:p-14 text-center">
          <div className="absolute inset-0 hero-glow" />
          <div className="relative">
            <h3 className="font-cond font-700 text-3xl md:text-4xl text-white">Device acting up? Let's fix it.</h3>
            <p className="mt-3 text-gray-400 max-w-xl mx-auto">
              Free diagnostics. Honest quote. Real repair. Reach out and we'll get back within the hour.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href={`tel:+1${CONTACT.phone}`} className="btn-blue px-7 py-3.5 rounded-md font-semibold flex items-center gap-2">
                <Phone className="w-4 h-4" /> Call for Free Advice
              </a>
              <a href={smsHref} className="btn-dark px-7 py-3.5 rounded-md font-semibold flex items-center gap-2">
                <MessageSquare className="w-4 h-4" /> Text Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Inventory;
